import React, { useState, useEffect } from 'react';

// Live Stats Bar - Top fixed
export const LiveStatsBar = () => {
 const [viewers, setViewers] = useState(23);
 useEffect(() => {
  const interval = setInterval(() => {
   setViewers(prev => Math.max(15, Math.min(35, prev + Math.floor(Math.random() * 5) - 2)));
  }, 8000);
  return () => clearInterval(interval);
 }, []);

 return (
  <div className="fixed top-0 left-0 right-0 z-50 py-2 px-4 text-center" data-testid="live-stats-bar" style={{ background: 'linear-gradient(90deg, #3B0E0E 0%, #5B1818 50%, #3B0E0E 100%)', borderBottom: '1px solid rgba(201,162,58,0.4)' }}>
   <div className="flex items-center justify-center gap-4 text-sm">
    <span className="flex items-center gap-2" style={{ color: '#E2C170' }}>
     <span className="w-2 h-2 rounded-full animate-pulse" style={{ background: '#E2C170' }}></span>
     <span className="font-bold">{viewers} लोग</span> अभी देख रहे हैं
    </span>
    <span style={{ color: '#C9A23A' }} className="hidden sm:inline">|</span>
    <span style={{ color: '#F0DCA0' }} className="font-bold hidden sm:inline">❖ अघोर विधि - श्रद्धा-विश्वास हो तभी आएं | क्षमतानुसार दक्षिणा</span>
   </div>
  </div>
 );
};

// Exit Intent Popup
export const ExitIntentPopup = () => {
 const [showPopup, setShowPopup] = useState(false);
 const [secondsLeft, setSecondsLeft] = useState(300);

 useEffect(() => {
  const handleMouseLeave = (e) => {
   if (e.clientY <= 0 && !showPopup) setShowPopup(true);
  };
  document.addEventListener('mouseleave', handleMouseLeave);
  return () => document.removeEventListener('mouseleave', handleMouseLeave);
 }, [showPopup]);

 useEffect(() => {
  if (showPopup && secondsLeft > 0) {
   const timer = setInterval(() => setSecondsLeft(prev => prev - 1), 1000);
   return () => clearInterval(timer);
  }
 }, [showPopup, secondsLeft]);

 const scrollToForm = () => {
  setShowPopup(false);
  const form = document.getElementById('contact-form-section');
  if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
 };

 if (!showPopup) return null;

 return (
  <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="exit-popup">
   <div className="absolute inset-0 backdrop-blur-sm" onClick={() => setShowPopup(false)} style={{ background: 'rgba(43,8,8,0.85)' }} />
   <div className="relative rounded-2xl p-5 sm:p-6 max-w-sm w-full" style={{ background: 'linear-gradient(135deg, #5B1818 0%, #3B0E0E 100%)', border: '2px solid #C9A23A', boxShadow: '0 20px 60px rgba(0,0,0,0.5)' }}>
    <div className="absolute top-0 left-0 w-full h-1 rounded-t-2xl" style={{ background: 'linear-gradient(90deg, #C9A23A, #F0DCA0, #C9A23A)' }}></div>
    
    <button onClick={() => setShowPopup(false)} className="absolute top-4 right-4 text-2xl" style={{ color: '#F0DCA0' }}>✕</button>
    
    <div className="text-center">
     <div className="w-14 h-14 mx-auto mb-3 rounded-full flex items-center justify-center animate-pulse" style={{ background: 'rgba(201,162,58,0.15)', border: '2px solid #C9A23A' }}>
      <span className="text-3xl" style={{ color: '#F0DCA0' }}>❖</span>
     </div>
     
     <h3 className="text-2xl font-black mb-1.5" style={{ fontFamily: "'Tiro Devanagari Hindi', 'Rozha One', serif", color: '#F0DCA0' }}>रुकिए!</h3>
     <p className="text-base mb-1.5" style={{ color: '#FBF6E9' }}>क्या आप बिना समाधान के जा रहे हैं?</p>
     <p className="text-xs mb-3" style={{ color: '#E8D8B0' }}>समस्या अपने आप ठीक नहीं होगी...</p>
     
     <div className="p-3 rounded-xl mb-3" style={{ background: 'rgba(201,162,58,0.10)', border: '1px solid rgba(201,162,58,0.4)' }}>
      <p className="font-bold text-base mb-1.5" style={{ color: '#F0DCA0' }}>सीमित समय का प्रस्ताव!</p>
      <div className="flex items-center justify-center gap-2 mb-3">
       <span style={{ color: '#FBF6E9' }}>समाप्त होने में:</span>
       <span className="px-3 py-1 rounded-lg font-bold text-xl animate-pulse" style={{ background: '#C9A23A', color: '#2A1208' }}>
        {Math.floor(secondsLeft / 60)}:{(secondsLeft % 60).toString().padStart(2, '0')}
       </span>
      </div>
      <div className="flex items-center justify-center gap-4 text-sm">
       <span className="font-bold text-lg" style={{ color: '#E2C170' }}>क्षमतानुसार दक्षिणा!</span>
      </div>
     </div>
     
     <button 
      onClick={scrollToForm}
      className="w-full py-3 text-base font-black rounded-xl transition-all transform hover:scale-105"
      style={{ background: 'linear-gradient(135deg, #C9A23A 0%, #F0DCA0 50%, #C9A23A 100%)', color: '#2A1208', fontFamily: "'Tiro Devanagari Hindi', serif", boxShadow: '0 6px 24px rgba(201,162,58,0.45)' }}
     >
      हाँ, मुझे समाधान चाहिए!
     </button>
     
     <button onClick={() => setShowPopup(false)} className="w-full mt-3 text-sm py-2 underline" style={{ color: '#E8D8B0', opacity: 0.7 }}>
      नहीं, मैं समस्या के साथ रहना चाहता हूँ
     </button>
    </div>
   </div>
  </div>
 );
};

// Countdown Timer
export const CountdownTimer = () => {
 const [timeLeft, setTimeLeft] = useState({ hours: 5, minutes: 59, seconds: 59 });
 useEffect(() => {
  const timer = setInterval(() => {
   setTimeLeft(prev => {
    if (prev.seconds > 0) return { ...prev, seconds: prev.seconds - 1 };
    if (prev.minutes > 0) return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
    if (prev.hours > 0) return { hours: prev.hours - 1, minutes: 59, seconds: 59 };
    return { hours: 23, minutes: 59, seconds: 59 };
   });
  }, 1000);
  return () => clearInterval(timer);
 }, []);
 const pad = (n) => n.toString().padStart(2, '0');

 return (
  <div className="p-6 rounded-2xl text-center" style={{ background: 'linear-gradient(135deg, #5B1818 0%, #3B0E0E 100%)', border: '1px solid #C9A23A' }} data-testid="countdown-timer">
   <p className="font-bold mb-2" style={{ color: '#F0DCA0' }}>विशेष मुहूर्त समाप्त हो रहा है:</p>
   <div className="flex items-center justify-center gap-3">
    {[
     { value: timeLeft.hours, label: 'घंटे' },
     { value: timeLeft.minutes, label: 'मिनट' },
     { value: timeLeft.seconds, label: 'सेकंड' }
    ].map((item, i) => (
     <React.Fragment key={i}>
      {i > 0 && <span className="text-2xl" style={{ color: '#F0DCA0' }}>:</span>}
      <div className="px-4 py-2 rounded-lg" style={{ background: '#17171C', border: '1px solid #C9A23A' }}>
       <span className="text-3xl font-black" style={{ color: '#F3EDE2' }}>{pad(item.value)}</span>
       <p className="text-xs" style={{ color: '#A8A199' }}>{item.label}</p>
      </div>
     </React.Fragment>
    ))}
   </div>
   <p className="mt-3 text-sm font-bold" style={{ color: '#FBF6E9' }}>अभी संपर्क करें — जांच क्षमतानुसार दक्षिणा!</p>
  </div>
 );
};

// Success Counter
export const SuccessCounter = () => {
 const [count, setCount] = useState(50000);
 useEffect(() => {
  const interval = setInterval(() => setCount(prev => prev + Math.floor(Math.random() * 3)), 10000);
  return () => clearInterval(interval);
 }, []);

 const items = [
  { value: `${count.toLocaleString()}+`, label: 'संतुष्ट भक्त' },
  { value: '97%', label: 'सफलता दर' },
  { value: '24', label: 'राज्यों में सेवा' },
  { value: '100%', label: 'गोपनीयता' },
 ];

 return (
  <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 my-8" data-testid="success-counter">
   {items.map((item, i) => (
    <div key={i} className="p-4 rounded-2xl text-center" style={{ background: '#17171C', border: '1px solid rgba(201,162,58,0.40)', boxShadow: '0 4px 20px rgba(0,0,0,0.55)' }}>
     <p className="text-3xl font-black" style={{ color: '#F3EDE2', fontFamily: "'Tiro Devanagari Hindi', serif" }}>{item.value}</p>
     <p className="text-sm mt-1" style={{ color: '#A8A199' }}>{item.label}</p>
    </div>
   ))}
  </div>
 );
};

// Media Mentions
export const MediaMentions = () => {
 return (
  <div className="py-12 overflow-hidden relative" style={{ background: '#0A0A0C' }} data-testid="devotee-gallery">
   <div className="text-center mb-6">
    <span className="inline-block tracking-[0.3em] text-[#C9A23A] font-bold text-sm mb-3 uppercase">भक्तों का अपार प्रेम</span>
    <h3 className="text-2xl sm:text-4xl font-black mb-2">लाखों भक्त — एक ही आस्था</h3>
    <p className="text-sm" style={{ color: '#A8A199' }}>देश भर से भक्त माता जी का आशीर्वाद लेने आते हैं</p>
   </div>
   <div className="relative" style={{ minHeight: '300px' }}>
    <div className="flex animate-marquee whitespace-nowrap items-center opacity-80" style={{ width: 'max-content' }}>
      <div className="relative flex-shrink-0 mx-2">
        <img src="/img/6f6b0bb1.webp" alt="चरण स्पर्श करते भक्त" className="w-64 h-44 object-cover rounded-xl" loading="lazy" style={{ border: '1px solid rgba(201,162,58,0.35)' }} />
        <p className="absolute bottom-1.5 left-0 right-0 text-center text-xs font-bold" style={{ color: '#F0DCA0', textShadow: '0 2px 8px #000' }}>चरण स्पर्श करते भक्त</p>
      </div>
      <div className="relative flex-shrink-0 mx-2">
        <img src="/img/e2c3bdaf.webp" alt="आशीर्वाद लेती भक्तिन" className="w-64 h-44 object-cover rounded-xl" loading="lazy" style={{ border: '1px solid rgba(201,162,58,0.35)' }} />
        <p className="absolute bottom-1.5 left-0 right-0 text-center text-xs font-bold" style={{ color: '#F0DCA0', textShadow: '0 2px 8px #000' }}>आशीर्वाद लेती भक्तिन</p>
      </div>
      <div className="relative flex-shrink-0 mx-2">
        <img src="/img/224ab4be.webp" alt="विशाल सत्संग सभा" className="w-64 h-44 object-cover rounded-xl" loading="lazy" style={{ border: '1px solid rgba(201,162,58,0.35)' }} />
        <p className="absolute bottom-1.5 left-0 right-0 text-center text-xs font-bold" style={{ color: '#F0DCA0', textShadow: '0 2px 8px #000' }}>विशाल सत्संग सभा</p>
      </div>
      <div className="relative flex-shrink-0 mx-2">
        <img src="/img/a3e7d966.webp" alt="परिवारों का प्रेम" className="w-64 h-44 object-cover rounded-xl" loading="lazy" style={{ border: '1px solid rgba(201,162,58,0.35)' }} />
        <p className="absolute bottom-1.5 left-0 right-0 text-center text-xs font-bold" style={{ color: '#F0DCA0', textShadow: '0 2px 8px #000' }}>परिवारों का प्रेम</p>
      </div>
      <div className="relative flex-shrink-0 mx-2">
        <img src="/img/922f24d7.webp" alt="हवन अनुष्ठान" className="w-64 h-44 object-cover rounded-xl" loading="lazy" style={{ border: '1px solid rgba(201,162,58,0.35)' }} />
        <p className="absolute bottom-1.5 left-0 right-0 text-center text-xs font-bold" style={{ color: '#F0DCA0', textShadow: '0 2px 8px #000' }}>हवन अनुष्ठान</p>
      </div>
      <div className="relative flex-shrink-0 mx-2">
        <img src="/img/25c09c80.webp" alt="कृतज्ञ भक्त" className="w-64 h-44 object-cover rounded-xl" loading="lazy" style={{ border: '1px solid rgba(201,162,58,0.35)' }} />
        <p className="absolute bottom-1.5 left-0 right-0 text-center text-xs font-bold" style={{ color: '#F0DCA0', textShadow: '0 2px 8px #000' }}>कृतज्ञ भक्त</p>
      </div>
      <div className="relative flex-shrink-0 mx-2">
        <img src="/img/6f6b0bb1.webp" alt="चरण स्पर्श करते भक्त" className="w-64 h-44 object-cover rounded-xl" loading="lazy" style={{ border: '1px solid rgba(201,162,58,0.35)' }} />
        <p className="absolute bottom-1.5 left-0 right-0 text-center text-xs font-bold" style={{ color: '#F0DCA0', textShadow: '0 2px 8px #000' }}>चरण स्पर्श करते भक्त</p>
      </div>
      <div className="relative flex-shrink-0 mx-2">
        <img src="/img/e2c3bdaf.webp" alt="आशीर्वाद लेती भक्तिन" className="w-64 h-44 object-cover rounded-xl" loading="lazy" style={{ border: '1px solid rgba(201,162,58,0.35)' }} />
        <p className="absolute bottom-1.5 left-0 right-0 text-center text-xs font-bold" style={{ color: '#F0DCA0', textShadow: '0 2px 8px #000' }}>आशीर्वाद लेती भक्तिन</p>
      </div>
      <div className="relative flex-shrink-0 mx-2">
        <img src="/img/224ab4be.webp" alt="विशाल सत्संग सभा" className="w-64 h-44 object-cover rounded-xl" loading="lazy" style={{ border: '1px solid rgba(201,162,58,0.35)' }} />
        <p className="absolute bottom-1.5 left-0 right-0 text-center text-xs font-bold" style={{ color: '#F0DCA0', textShadow: '0 2px 8px #000' }}>विशाल सत्संग सभा</p>
      </div>
      <div className="relative flex-shrink-0 mx-2">
        <img src="/img/a3e7d966.webp" alt="परिवारों का प्रेम" className="w-64 h-44 object-cover rounded-xl" loading="lazy" style={{ border: '1px solid rgba(201,162,58,0.35)' }} />
        <p className="absolute bottom-1.5 left-0 right-0 text-center text-xs font-bold" style={{ color: '#F0DCA0', textShadow: '0 2px 8px #000' }}>परिवारों का प्रेम</p>
      </div>
      <div className="relative flex-shrink-0 mx-2">
        <img src="/img/922f24d7.webp" alt="हवन अनुष्ठान" className="w-64 h-44 object-cover rounded-xl" loading="lazy" style={{ border: '1px solid rgba(201,162,58,0.35)' }} />
        <p className="absolute bottom-1.5 left-0 right-0 text-center text-xs font-bold" style={{ color: '#F0DCA0', textShadow: '0 2px 8px #000' }}>हवन अनुष्ठान</p>
      </div>
      <div className="relative flex-shrink-0 mx-2">
        <img src="/img/25c09c80.webp" alt="कृतज्ञ भक्त" className="w-64 h-44 object-cover rounded-xl" loading="lazy" style={{ border: '1px solid rgba(201,162,58,0.35)' }} />
        <p className="absolute bottom-1.5 left-0 right-0 text-center text-xs font-bold" style={{ color: '#F0DCA0', textShadow: '0 2px 8px #000' }}>कृतज्ञ भक्त</p>
      </div>
    </div>
    <div className="pointer-events-none absolute inset-0" style={{ background: 'linear-gradient(90deg, #0A0A0C 0%, transparent 12%, transparent 88%, #0A0A0C 100%)' }} />
   </div>
   <div className="flex justify-center -mt-24 sm:-mt-28 relative z-10">
    <img src="/img/586c55f1.webp" alt="माता मलिहा आशीर्वाद" className="w-64 sm:w-80 h-auto" loading="lazy"
      style={{ mixBlendMode: 'screen', maskImage: 'radial-gradient(ellipse 70% 80% at 50% 45%, #000 50%, transparent 95%)', WebkitMaskImage: 'radial-gradient(ellipse 70% 80% at 50% 45%, #000 50%, transparent 95%)' }} />
   </div>
   <p className="text-center text-base font-bold tracking-widest -mt-12 relative z-20" style={{ color: '#E2C170', textShadow: '0 2px 8px #000' }}>माता मलीहा जी — सदैव आशीर्वाद देती हुईं</p>
   <style>{`
    @keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
    .animate-marquee { animation: marquee 45s linear infinite; }
   `}</style>
  </div>
 );
};
